import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import IconButton from '../IconButton';
import { DSIcon } from '../../../base';

import Button from '../Button';

import styles from './BackButtonDesktop.module.scss';

const BackButtonDesktop = ({ className = '', ...props }) => {
  const classes = classNames(styles['back-button-desktop'], className);
  return (
    <Button
      className={classes}
      contentClassName={styles['back-button-desktop__content']}
      {...props}
    >
      <DSIcon
        name="arrow_left"
        className={styles['back-button-desktop__icon']}
      />
      {trans('listing.back')}
    </Button>
  );
};

BackButtonDesktop.propTypes = {
  ...IconButton.propTypes
};

export default BackButtonDesktop;
